import React              from 'react';
import classNames         from 'classnames';
import { useTranslation } from 'react-i18next';
import * as PropTypes     from 'prop-types';
import DV                 from 'ts-data-validator';

import './style.scss';

import Meta          from '../../../components/meta';
import PageHeader    from '../../../components/pageHeader';
import RenderButton  from '../../../components/buttons/base/RenderButton';

const Error = (props) => {
  const {
          centered,
          description,
          image,
          meta,
          title,
        } = props;

  const { t } = useTranslation();

  React.useEffect(() => {
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });

      if (!document.body.classList.contains('error-page')) {
        document.body.classList.add('error-page');
      }
    }
    return () => {
      if (!isSSR() && document.body.classList.contains('error-page')) {
        document.body.classList.remove('error-page');
      }
    };
  }, []);

  return (
    <div className={classNames('page-container', { centered })}>
      <div className={'container'}>
        <div className={'page-content'}>
          <Meta
            description={t(meta.description || 'client_error404_mete_description')}
            isIndexed={false}
            keywords={t(meta.keywords || 'default_meta_keywords')}
            title={t(meta.title || 'client_error404_meta_title')}
          />
          <PageHeader>{t(title)}</PageHeader>
          <main>
            {DV.isNotEmptyString(description) && (
              <article>
                <section>
                  <p>
                    {t(description)}
                  </p>
                </section>
              </article>
            )}
            <section className={'to-catalog'}>
              <div className={'container'}>
                <RenderButton type={'link'} uri={'/'} label={t('client_goToMain')} />
              </div>
            </section>
          </main>
        </div>
        {DV.isNotEmptyString(image) && (
          <picture>
            <img
              src={image}
              alt={title}
            />
          </picture>
        )}
      </div>
    </div>
  );
};

Error.defaultProps = {
  centered:  false,
  goToFront: true,
};

Error.propTypes = {
  centered:    PropTypes.bool,
  description: PropTypes.string,
  goToFront:   PropTypes.bool,
  image:       PropTypes.string.isRequired,
  meta:        PropTypes.exact({
    description: PropTypes.string,
    keywords:    PropTypes.string,
    title:       PropTypes.string,
  }),
  title:       PropTypes.string.isRequired,
};

export default Error;